export default {
  tags: {
    new: '_S_NEW',
    rejected: '_S_REJECTED',
    isBeingProcessed: '_S_PREVIEW_STATUS',
    // Persisted while the ProcessDocument task runs (upload and reprocess);
    // isBeingProcessed above is derived server-side from the preview-trial tag.
    isProcessing: '_S_PROCESSING',
    isScheduledAcceptance: '_S_SCHEDULED_ACCEPTANCE',
    isAccepted: '_S_ACCEPTED',
    isScheduledApproval: '_S_SCHEDULED_APPROVAL',
    paid: '_S_PAID',
    unpaid: '_S_UNPAID',
    financial: '_T_FIN',
    general: '_T_GEN',
    approvalPending: '_S_APPROVAL_PENDING',
    approvalComplete: '_S_APPROVAL_COMPLETE',
    approvalRejected: '_S_APPROVAL_REJECTED',
    publishFailed: '_S_PUBLISH_FAILED',
    trash: '_C_TAG_TRASH',
    paymentInProgress: '_S_PAYMENT_IN_PROGRESS',
  },
  doctype: {
    financial: 'financial',
    general: 'general',
  },
};

export const WS_GRID_PRESET_TYPES = {
  default: 'default',
  shared: 'shared',
  custom: 'custom',
};

export const WS_GRID_DEFAULT_PRESET_ID = 'default';

export const SEARCH_DEFAULT_MAX_RESULT = 30;

export const GRID_PAGE_SIZE = [100, 500, 1000];

export const GRID_PER_PAGE_DEFAULT = 500;

export const PublishTypes = Object.freeze({
  Publish: 'publish',
  ForcePublish: 'force_publish',
  PublishAndStay: 'publish_and_stay',
  SchedulePublish: 'schedule_publish',
});
